export default __webpack_public_path__ + "static/media/HeaderBanner_2.77a4fba2.png";